// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"accessibility-module--wrapper--1OT9v"};